var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99991 3.86914C7.1573 3.86914 5.6582 5.36824 5.6582 7.21085C5.6582 9.05346 7.1573 10.5526 8.99991 10.5526C10.8425 10.5526 12.3416 9.05346 12.3416 7.21085C12.3416 5.36824 10.8426 3.86914 8.99991 3.86914ZM8.99991 9.14553C7.93313 9.14553 7.06523 8.27763 7.06523 7.21085C7.06523 6.14407 7.93313 5.27616 8.99991 5.27616C10.0667 5.27616 10.9346 6.14407 10.9346 7.21085C10.9346 8.27763 10.0667 9.14553 8.99991 9.14553Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00014 0C5.02393 0 1.78906 3.2349 1.78906 7.21107V7.41041C1.78906 9.42135 2.94198 11.7647 5.21588 14.3753C6.86429 16.2679 8.48967 17.5875 8.55801 17.6427L9.00014 18L9.44226 17.6428C9.51064 17.5875 11.136 16.2679 12.7844 14.3754C15.0583 11.7647 16.2112 9.42138 16.2112 7.41045V7.21111C16.2112 3.2349 12.9763 0 9.00014 0ZM14.8042 7.41045C14.8042 10.8088 10.4254 14.9226 9.00014 16.1715C7.57444 14.9222 3.19609 10.8086 3.19609 7.41045V7.21111C3.19609 4.01077 5.79979 1.40706 9.00014 1.40706C12.2005 1.40706 14.8042 4.01077 14.8042 7.21111V7.41045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8055ae943c1a6841b792ebb9607bb3c4.svg";
export { ForwardRef as ReactComponent };